import { useEffect, useState } from 'react'
import { useSearchParams, Link } from 'react-router-dom'
import { Button } from '@alertwhale/ui'
import { api } from '@/lib/api'
import { CheckCircle, XCircle, Loader2 } from 'lucide-react'

export function VerifyEmailPage() {
  const [searchParams] = useSearchParams()
  const token = searchParams.get('token')
  const [status, setStatus] = useState<'loading' | 'success' | 'error'>('loading')

  useEffect(() => {
    async function verifyEmail() {
      if (!token) {
        setStatus('error')
        return
      }

      try {
        await api.get(`/auth/verify-email/${token}`)
        setStatus('success')
      } catch {
        setStatus('error')
      }
    }

    verifyEmail()
  }, [token])

  if (status === 'loading') {
    return (
      <div className="p-8">
        <div className="space-y-4 text-center">
          <div className="mx-auto w-12 h-12 flex items-center justify-center">
            <Loader2 className="w-8 h-8 animate-spin text-whale-400" />
          </div>
          <h1 className="text-2xl font-bold text-white">Verifying email...</h1>
          <p className="text-slate-400">Please wait while we verify your email address</p>
        </div>
      </div>
    )
  }

  if (status === 'success') {
    return (
      <div className="p-8">
        <div className="space-y-4 text-center mb-8">
          <div className="mx-auto w-12 h-12 bg-emerald-500/20 rounded-full flex items-center justify-center">
            <CheckCircle className="w-6 h-6 text-emerald-400" />
          </div>
          <h1 className="text-2xl font-bold text-white">Email verified</h1>
          <p className="text-slate-400">
            Your email address has been verified successfully
          </p>
        </div>
        <Link to="/login">
          <Button className="w-full bg-whale-500 hover:bg-whale-600 text-white font-medium">
            Continue to login
          </Button>
        </Link>
      </div>
    )
  }

  return (
    <div className="p-8">
      <div className="space-y-4 text-center mb-8">
        <div className="mx-auto w-12 h-12 bg-red-500/20 rounded-full flex items-center justify-center">
          <XCircle className="w-6 h-6 text-red-400" />
        </div>
        <h1 className="text-2xl font-bold text-white">Verification failed</h1>
        <p className="text-slate-400">
          This verification link is invalid or has expired
        </p>
      </div>
      <Link to="/login">
        <Button className="w-full bg-whale-500 hover:bg-whale-600 text-white font-medium">
          Go to login
        </Button>
      </Link>
    </div>
  )
}
